import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';

import { Subject } from 'rxjs';
import { map } from 'lodash';

import { UserAdministrationService } from '@nrwl/common-lib';

import { UserWizardService } from '../../../services/user/user.wizard.service';
import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';

@Component({
  selector: 'users-group-html',
  templateUrl: './users.group.html',
  styleUrls: ['../wizard.user.style.scss'],
  providers: []
})
export class UsersGroupComponent implements IWizardContentComponent, OnInit, OnDestroy {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  groupNames: Array<string>;
  name: string;

  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(
    private readonly wizardService: UserWizardService,
    private readonly userAdministrationService: UserAdministrationService
  ) {}

  ngOnInit() {
    this.step.form = this.form;
    this.name = undefined;
    this.mapAllGroups();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.wizardService.editMode = false;
  }

  nameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'nameInput',
      key: 'name',
      newValue: this.name,
      isValid: this.step.form.controls.name.valid
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  getGravatarUrl(email: any): any {
    return this.wizardService.userService.getGravatarUrl(email);
  }

  private mapAllGroups() {
    this.userAdministrationService.getGroups$().subscribe(result => {
      this.groupNames = map(result.success, 'name');
    });
    const nameInput = this.stateHistory(this.componentId, 'nameInput');
    if (nameInput && nameInput.value) {
      this.name = nameInput.value;
    }
  }
}
